import React, { Component } from 'react'
import webApi from '../../../../../../utilities/web-api';
import { header } from './../../../../../../utilities/page';

export default class CreateCategory extends Component {
    state = {}

    componentWillMount(){
        this.setState(this.props.position)
    }

    handleCreate = () => {
        let {title, description} = this.state
        if(!title) return header.getSnackbar("Название должности не заполнено")

        let obj = {title, description}
        
        if(!obj.description) delete obj.description
        webApi.updatePositionId(obj, this.state.id)
        .then(data => {
            if(data.status === 200){
                header.getSnackbar("Должность успешно отредактирована")
                this.props.handlePage('view')
            }
        })

        //webApi.updatePositionId
    }

    handleInput = e => {
        this.setState({[e.target.name]:e.target.value})
    }

    render() {
        let {title} = this.state
        return (  
            <div>
                <span className="href" onClick={() => this.props.handlePage('view')}><i className="fas fa-arrow-left color-blue"></i> Вернуться назад</span><br/><br/>     
                <div className="create-form">
                    <span><b>Название должности</b></span> <br/>
                    <input name = "title" onChange={this.handleInput} defaultValue={this.state.title && this.state.title} type="text" placeholder="Введите название категории"/> <br/><br/>
                    <span><b>Описание</b></span> <br/>
                    <input name = "description" onChange={this.handleInput} defaultValue={this.state.description && this.state.description} type="text" placeholder="Введите описание должности"/> <br/><br/>
                    <div className="btnSaveProfile fl-left" onClick={this.handleCreate}>Обновить</div>
                </div>
            </div>
        )
    }
}